// extracted by css-extract-rspack-plugin
export default {"HeadlineImage":"HeadlineImage-Lx3Nt8","headlineImage":"HeadlineImage-Lx3Nt8"};